import type { Lease } from '@/api/types'

// 느린 주기 스윕이 VM 안에서 읽은 것(#227). 등록되지 않은 키의 수와, 접속 키가 빠졌는지 — 둘 중 하나라도 있을 때만 한 줄이다.
// 지우지 않는다: 기록이 목적이고, 지우는 것은 사람의 결정(키 재발급이 전체를 덮어쓴다)이다. 사용자 상세와 관리자 VM 상세가 같은 줄을 쓴다.
// 재발급하라는 지시는 그 칩이 선 화면에만 붙는다(`rotate`) — 관리자가 남의 VM 에서 보는 줄은 막힘만 말한다.

export function GuestKeysLine({ lease: l, rotate }: { lease: Lease; rotate: boolean }) {
  const g = l.guest_keys
  if (!g || (g.unmanaged === 0 && !g.gateway_key_missing)) return null
  return (
    <div className="mt-2 flex flex-wrap items-center gap-x-3 text-[11px] text-warn-ink">
      {g.unmanaged > 0 ? <span>등록되지 않은 키 {g.unmanaged}개</span> : null}
      {g.gateway_key_missing ? <span>{rotate ? '접속할 수 없는 상태입니다. 키를 재발급하세요.' : '접속할 수 없는 상태입니다.'}</span> : null}
    </div>
  )
}
